import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Container from 'common/components/UI/Container';
import GatsbyImage from 'common/components/GatsbyImage';
import SectionWrapper, { ContentWrapper } from './fundRaising.style';
import GraphFeatureImg from 'common/assets/image/cryptoModern/graph-feature.png';

const DesignedAndBuilt = () => {
  const Data = useStaticQuery(graphql`
    query {
      illustration: file(
        relativePath: { eq: "image/cryptoModern/fund-graph.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);
  return (
    <SectionWrapper id="startwithnadi">
      <Container>
        <ContentWrapper className='column-reverse'>
          <div className="image">
            <GatsbyImage
              src={
                (Data.illustration !== null) | undefined
                  ? Data.illustration.childImageSharp.gatsbyImageData
                  : {}
              }
              alt="Graph Image"
            />
          </div>
          <div className="content">
            <Heading content="Get Started Today" />
            <Text content="Simplify Your Enterprise with NadiAI. Join the growing number of businesses leveraging the power of AI agents to automate and optimize their operations. With NadiAI, you’re just a few steps away from transforming the way your enterprise works." />
            {/*<Image src={GraphFeatureImg} alt="Graph Feature Image" />*/}
          </div>
          <div className="gradientDiv"> </div>
        </ContentWrapper>
      </Container>
    </SectionWrapper>
  );
};

export default DesignedAndBuilt;
